export default __webpack_public_path__ + "static/media/0.cc1851bf.jpg";